export const GET_AUTH = 'auth.GET_AUTH'
export const SET_AUTH = 'auth.SET_AUTH'

export const getAuth = (callback) => ({
  type: GET_AUTH,
  callback,
})

export const setAuth = (data) => ({
  type: SET_AUTH,
  data,
})
